import thunkMiddleware from 'redux-thunk'

export default [
    thunkMiddleware
]


// WEBPACK FOOTER //
// ./config/middleware.js